// extracted by mini-css-extract-plugin
export default {"content-wrapper-image":"ContentWrapperImage_content-wrapper-image__TGd4X","small":"ContentWrapperImage_small__VtDIc","overlay":"ContentWrapperImage_overlay__GHMY+"};